// extracted by mini-css-extract-plugin
module.exports = {"container":"Category_container__1M4ON","margin":"Category_margin__JjMPA","sheet":"Category_sheet__3p8J2","active":"Category_active__2U7q3","padding":"Category_padding__1NPAN"};